import { HashTag } from "./HashTag"
import { getHashTags } from "../../api/v1/hashtag/get"

export const fetchHashTags = (): Promise<HashTag[]> => {
  return getHashTags().then((res) => res.results)
}
